"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var glamor_1 = require("glamor");

var glamor_tachyons_1 = require("glamor-tachyons");

var render_utils_1 = require("../render/render_utils");

var DEFAULT_SUBSURFACE_OPTS = {
  prepend: false
};

function subSurface(parent, name) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = render_utils_1.getDrawArea(parent);
  var style = glamor_1.css(Object.assign({
    '& canvas': {
      display: 'block'
    }
  }, glamor_tachyons_1.tachyons('mv2')));
  var titleStyle = glamor_1.css(Object.assign({
    backgroundColor: 'white',
    display: 'inline-block',
    boxSizing: 'border-box',
    borderBottom: '1px solid #357EDD',
    lineHeight: '2em',
    padding: '0 10px 0 10px',
    marginBottom: '20px'
  }, glamor_tachyons_1.tachyons('fw6 tl')));
  var options = Object.assign({}, DEFAULT_SUBSURFACE_OPTS, opts);
  var sub = container.querySelector("div[data-name=".concat(name, "]"));

  if (!sub) {
    sub = document.createElement('div');
    sub.setAttribute('class', "".concat(style));
    sub.dataset.name = name;

    if (options.title) {
      var title = document.createElement('div');
      title.setAttribute('class', "subsurface-title ".concat(titleStyle));
      title.innerText = options.title;
      sub.appendChild(title);
    }

    if (options.prepend) {
      container.insertBefore(sub, container.firstChild);
    } else {
      container.appendChild(sub);
    }
  }

  return sub;
}

exports.subSurface = subSurface;